import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  fileIcon: {
    marginRight: theme.spacing(1.2),
    color: theme.custom.color.pewter,
    fontSize: "28px",
    marginLeft: theme.spacing(0.5),
  },
  downloadIcon: {
    color: theme.palette.primary.main,
    fontSize: "20px",
  },
  downloadWrapper: {
    maxWidth: "300px",
    borderRadius: "8px",
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.2),
  },
  downloadLabel: {
    fontSize: "14px",
    lineHeight: "24px",
    color: theme.custom.color.blackRussian,
    textTransform: "capitalize",
  },
}));
